import { IntlShape } from 'react-intl';

export const routeTranslate = (intl: IntlShape, id: string) => {
    return intl.formatMessage({
        id,
    });
};
